import { useTreatmentsWithConfig } from '@splitsoftware/splitio-react';

export const useFeatureFlag = (featureName: string): boolean => {
  const { treatments, isReady } = useTreatmentsWithConfig({
    names: [featureName],
  });

  return isReady && treatments[featureName]?.treatment === 'on';
};

export const useFeatureFlagWithReady = (featureName: string) => {
  const { treatments, isReady } = useTreatmentsWithConfig({
    names: [featureName],
  });

  return {
    ready: isReady,
    enabled: isReady && treatments[featureName]?.treatment === 'on',
  };
};
